const initialState = {
  trigger: "",
};

const triggerReducers = (state = initialState, action) => {
  switch (action.type) {
    case "TRIGGER":
      return {
        ...state,
        trigger: action.payload,
      };
    default:
      return state;
  }
};

export default triggerReducers;
